import { z } from 'zod4';

import { fixture } from './fixtures';

export const User = z.object({
	id: z.string(),
	displayName: z.string(),
	email: z.string(),
	profilePic: z.string(),
	username: z.string(),
});

export const UserArray = z.array(User);

export type User = z.infer<typeof User>;

// Fixture functions using manual generators
export const userFixture = (overrides: Partial<User> = {}): User => ({
	id: fixture.id(),
	displayName: fixture.name('User'),
	email: fixture.email(),
	profilePic: fixture.url('avatar'),
	username: fixture.username(),
	...overrides,
});

// Utility function for user tag (replicating the original getter)
export const getUserTag = (username: string): string => `@${username}`;
